import { render, staticRenderFns } from "./modelPriceChangeApply.vue?vue&type=template&id=9679839e&scoped=true&"
import script from "./modelPriceChangeApply.vue?vue&type=script&lang=js&"
export * from "./modelPriceChangeApply.vue?vue&type=script&lang=js&"
import style0 from "./modelPriceChangeApply.vue?vue&type=style&index=0&id=9679839e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9679839e",
  null
  
)

export default component.exports